import { render, staticRenderFns } from "./OperateApiScope.vue?vue&type=template&id=2affb522&scoped=true"
import script from "./OperateApiScope.vue?vue&type=script&lang=js"
export * from "./OperateApiScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affb522",
  null
  
)

export default component.exports